// src/components/ClientValidator.mjs
import React from 'react';
import { useParams } from 'react-router-dom';
import { ClientProvider, useClient } from '../context/ClientContext.mjs';
import ClientNotFound from './ClientNotFound.mjs';
import LoadingSpinner from './LoadingSpinner.mjs';

const ClientContent = ({ children }) => {
    const { client, isLoading, error } = useClient();

    if (isLoading) {
        return <LoadingSpinner />;
    }

    if (error || !client) {
        return <ClientNotFound />;
    }

    return children;
};

const ClientValidator = ({ children }) => {
    const { clientName } = useParams();

    return (
        <ClientProvider clientName={clientName}>
            <ClientContent>
                {children}
            </ClientContent>
        </ClientProvider>
    );
};

export default ClientValidator;
